<template>
  <div v-if="rewardAttachmentUploads" class="reward-attachment">
    <small v-if="imageError" class='file-warning error-label form-message'>{{imageError}}</small>
    <div class="image-container text-center"
         v-for="attachmentToUpload in rewardAttachmentUploads">
      <upload-attachment :key="attachmentToUpload.type + rewardId"
                         :attachment="attachmentToUpload.type === 'coupon' ? couponImage : preloadImage"
                         deleteClasses="delete-image"
                         deleteText="remove"
                         fileUploadClasses="image-upload"
                         :label="attachmentToUpload.type"
                         loadingClasses="offer-loading"
                         :ownerId="rewardId"
                         ownerType="Reward"
                         shouldReload
                         :showInputFile="attachmentToUpload.type === 'coupon' ? !couponImage : !preloadImage"
                         showPreview
                         :uploadConfig="attachmentToUpload"
                         @configureAttachment="configureAttachmentResponse"
                         @reloadAttachments="loadImages">
      </upload-attachment>
    </div>
  </div>
</template>

<script>
  import axiosConfig from '../../config/axios'
  import { isObject } from '../../utilities'
  import UploadAttachment from '../FormItems/UploadAttachment'

  export default {
    props: {
      rewardAttachmentUploads: Array,
      rewardId: Number,
      rewardOwnerId: [Number, String],
      rewardOwnerType: String,
    },

    components: {
      UploadAttachment,
    },

    data() {
      return {
        couponImage: null,
        hasLoaded: false,
        imageError: null,
        preloadImage: null,
      }
    },

    methods: {
      configureAttachmentResponse(responseData) {
        if (responseData.label === 'preload') {
          this.preloadImage = responseData
        } else {
          this.couponImage = responseData
        }
      },

      loadImages() {
        const rewardOwner = { owner_id: this.rewardOwnerId, owner_type: this.rewardOwnerType },
          url = `/api/v3/campaign_rewards/${this.rewardId}/reward_attachments`
        axiosConfig.get(url, { params: rewardOwner })
          .then((response) => {
            const images = response.data
            if (isObject(images)) {
              let coupon,
                preload
              this.imageError = null
              images.forEach( image => {
                if (image.label === 'coupon') { coupon = image }
                if (image.label === 'preload') { preload = image }
              })
              this.couponImage = coupon ? coupon : null
              this.preloadImage = preload ? preload : null
            } else {
              this.imageError = 'error loading reward images'
            }
          })
          .catch((error) => {
            this.imageError = `could not load reward images. ${error}`
            this.hasLoaded = true
          })
      },
    },

    created() {
      this.loadImages()
    },

    watch: {
      couponImage: function() {
        this.$emit('setRewardAttachment', 'coupon', this.couponImage)
      },

      preloadImage: function() {
        this.$emit('setRewardAttachment', 'preload', this.preloadImage)
      },
    }
  }
</script>
